import { DatabaseWrapper } from './database.wrapper';
import { Database } from './database';
import { Db2Wrapper } from 'src/app/modules/databases/db2/db2.wrapper';
import { NetezzaWrapper } from 'src/app/modules/databases/netezza/netezza.wrapper';
import { TeradataWrapper } from 'src/app/modules/databases/teradata/teradata.wrapper';
import { OracleWrapper } from 'src/app/modules/databases/oracle/oracle.wrapper';
import { FlatfileWrapper } from 'src/app/modules/databases/flatfile/flatfile.wrapper';
import { HiveWrapper } from 'src/app/modules/databases/hive/hive.wrapper';
import { MssqlWrapper } from 'src/app/modules/databases/mssql/mssql.wrapper';
import { BiginsightsWrapper } from 'src/app/modules/databases/biginsights/biginsights.wrapper';
import { CobolWrapper } from 'src/app/modules/databases/cobol/cobol.wrapper';
import { SalesforceWrapper } from 'src/app/modules/databases/salesforce/salesforce.wrapper';
import { ExadataWrapper } from 'src/app/modules/databases/exadata/exadata.wrapper';
import { GreenPlumWrapper } from 'src/app/modules/databases/greenplum/greenplum.wrapper';
import { HawqWrapper } from 'src/app/modules/databases/hawq/hawq.wrapper';
import { HdfsCommandWrapper } from 'src/app/modules/databases/hdfs/hdfs.wrapper';
import { JsonWrapper } from 'src/app/modules/databases/json/json.wrapper';
import { HbaseWrapper } from 'src/app/modules/databases/hbase/hbase.wrapper';
import { XsdWrapper } from 'src/app/modules/databases/xsd/xsd.wrapper';
import { SpliceMachineWrapper } from 'src/app/modules/databases/splicemachine/splicemachine.wrapper';
import { PostgresWrapper } from 'src/app/modules/databases/postgres/postgres.wrapper';
import { TwitterWrapper } from 'src/app/modules/databases/twitter/twitter.wrapper';
import { FacebookWrapper } from 'src/app/modules/databases/facebook/facebook.wrapper';
import { SparkWrapper } from 'src/app/modules/databases/spark/spark.wrapper';
import { JmsWrapper } from 'src/app/modules/databases/jms/jms.wrapper';
import { SybaseWrapper } from 'src/app/modules/databases/sybase/sybase.wrapper';
import { SasWrapper } from 'src/app/modules/databases/sas/sas.wrapper';
import { KafkaWrapper } from 'src/app/modules/databases/kafka/kafka.wrapper';
import { CassandraWrapper } from 'src/app/modules/databases/cassandra/cassandra.wrapper';
import { ThoughtspotWrapper } from 'src/app/modules/databases/thoughtspot/thoughtspot.wrapper';
import { SnowflakeWrapper } from 'src/app/modules/databases/snowflake/snowflake.wrapper';
import { MysqlWrapper } from 'src/app/modules/databases/mysql/mysql.wrapper';
import { BigqueryWrapper } from 'src/app/modules/databases/bigquery/bigquery.wrapper';
import { RestWrapper } from 'src/app/modules/databases/rest/rest.wrapper';
import { AvroWrapper } from 'src/app/modules/databases/avro/avro.wrapper';
import { ParquetWrapper } from 'src/app/modules/databases/parquet/parquet.wrapper';
import { AmazonS3Wrapper } from 'src/app/modules/databases/amazons3/amazons3.wrapper';
import { DruidWrapper } from 'src/app/modules/databases/druid/druid.wrapper';
import { RedshiftWrapper } from 'src/app/modules/databases/redshift/redshift.wrapper';
import { GoogleCloudStorageWrapper } from 'src/app/modules/databases/google-cloud-storage/goolge_cloud_storage.wrapper';
import { AuroraWrapper } from 'src/app/modules/databases/aurora/aurora.wrapper';
import { SharePointWrapper } from 'src/app/modules/databases/sharepoint/sharepoint.wrapper';//sharmi & piyush 30-08-24
import { GoogleDoubleClickSearchWrapper } from 'src/app/modules/databases/google-doubleclick-search/google_doubleclick_search.wrapper';
import { DentrixWrapper } from 'src/app/modules/databases/dentrix/dentrix.wrapper';
import { EagleSoftWrapper } from 'src/app/modules/databases/eaglesoft/eaglesoft.wrapper';
import { GoogleAnalyticsWrapper } from 'src/app/modules/databases/googleanalytics/googleanalytics.wrapper';
import { MariaWrapper } from 'src/app/modules/databases/maria/maria.wrapper';
import { DynamoWrapper } from 'src/app/modules/databases/dynamodb/dynamo.wrapper';
import { RavenWrapper } from 'src/app/modules/databases/ravendb/ravendb.wrapper';
import { Azure_blob_storageWrapper } from 'src/app/modules/databases/azure-blob-storage/azure_blob_storage.wrapper';
import { GoogleAdwordsWrapper } from 'src/app/modules/databases/googleadwords/googleadwords.wrapper';
import { GooglePubSubWrapper } from 'src/app/modules/databases/googlepubsub/googlepubsub.wrapper.';
import { Datatype } from './datatype';
import { ActiveDirectoryWrapper } from 'src/app/modules/databases/activedirectory/active-directory.wrapper';
import { GenericWrapper } from 'src/app/modules/databases/generic/generic.wrapper';
import { LabelValueObj } from '../beans/labelvalueobj';
import { MongoDbWrapper } from 'src/app/modules/databases/mongodb/mongodb.wrapper';
import { AzureSynapseWrapper } from 'src/app/modules/databases/azuresynapse/azuresynapse.wrapper';
import { IotHubWrapper } from 'src/app/modules/databases/iothub/iothub.wrapper';
import { ConnectDirectMainframeWrapper } from 'src/app/modules/databases/connectdirectmainframe/connectdirectmainframe.wrapper';
import { Office365Wrapper } from 'src/app/modules/databases/office365/office365.wrapper';
import { SapHanaWrapper } from 'src/app/modules/databases/saphana/sapahana.wrapper';
import { JsonCWrapper } from 'src/app/modules/databases/jsonc/jsonc.wrapper';//add by sharmi on 4-3-25
import { DatabaseEnum } from './databases.enum';
import { Param } from '../models/domain/param';
import { DataMaskingWrapper } from 'src/app/modules/databases/datamasking/datamasking.wrapper';
import { PhoenixWrapper } from 'src/app/modules/databases/phoenix/phoenix.wrapper';
import { ExcelWrapper } from 'src/app/modules/databases/excel/excel.wrapper';
import { RestAPIWrapper } from 'src/app/modules/databases/restapi/restapi.wrapper';
import { VerticaWrapper } from 'src/app/modules/databases/vertica/vertica.wrapper';
import { SmartsheetWrapper } from 'src/app/modules/databases/smartsheet/smartsheet.wrapper.';
import { IcebergWrapper } from 'src/app/modules/databases/iceberg/iceberg.wrapper';


export class DatabaseWrappersFactory {
    private static instance: DatabaseWrappersFactory;

    static getInstance() {
        if (!DatabaseWrappersFactory.instance) {
            DatabaseWrappersFactory.instance = new DatabaseWrappersFactory();
        }

        return DatabaseWrappersFactory.instance;
    }

    databases: Array<Database>;
    databaseWrappersMap: Map<number, DatabaseWrapper>;

    /**
    * DatabaseWrappersFactory is a singleton class, so use DatabaseWrappersFactory.getInstance() method instead of creating new DatabaseWrappersFactory().
    */
    private constructor() {
        this.databases = Array<Database>();
        this.databaseWrappersMap = new Map<number, DatabaseWrapper>();
    }

    setDatabases(databases: Array<Database>): void {
        this.databases = databases;
        this.databaseWrappersMap.clear();
    }

    getDatabaseWrapper(id: number): DatabaseWrapper {
        let databaseWrapper: DatabaseWrapper = this.databaseWrappersMap.get(id);
        if (databaseWrapper) return databaseWrapper;

        let database: Database
        if (id == -1) {
            databaseWrapper = new DatabaseWrapper(new Database());
            this.databaseWrappersMap.set(databaseWrapper.database.id, databaseWrapper);

            return databaseWrapper;
        }

        for (let i: number = 0; i < this.databases.length; i++) {
            if (this.databases[i].id == id) {
                database = this.databases[i];

                databaseWrapper = this.createDatabaseWrapper(database);
                this.databaseWrappersMap.set(database.id, databaseWrapper);

                databaseWrapper.labelValueObjs = new Array<LabelValueObj>();

                let labelValueObjs: Array<LabelValueObj>
                for (let j: number = 0; j < database.datatype.length; j++) {
                    let dataType: Datatype = database.datatype[j] as Datatype;

                    let labelValueObj: LabelValueObj = new LabelValueObj();

                    labelValueObj.id = dataType.id;
                    labelValueObj.label = dataType.name;
                    labelValueObj.value = dataType.name;

                    databaseWrapper.labelValueObjs.push(labelValueObj);

                    databaseWrapper.datatypesMap.set(database.id + '.' + dataType.id, dataType);
                }

                return databaseWrapper;
            }
        }

        return null;
    }

    getRelatedDatabaseIds(dbTyp_Id: number): Array<number> {
        switch (dbTyp_Id) {
            case 3: return [9, 15, 17, 32];

            case 6: return [14, 16, 33];

            case 31: return [3, 15, 17];

            case 18: return [14];

            case 8: return [14];

            case 37: return [3, 9, 15, 17, 32];

            case 47: return [3, 9, 15, 17, 32];

            default: return [];
        }
    }

     /**
     * @description
     * `isFileTypeDatabase` method used to check database id is file type or not.
     * @param < number > dbTyp_Id - dbTyp_Id will be passed as argument to check with
     * file type database ids.
     * #### Method implementation
     * `fileTypeDatabaseIds' is array to store the file type data base ids.
     *
     * If the dbTyp_Id is present in `fileTypeDatabaseIds` array then will return as true.
     *
     * If the dbTyp_Id is not present in `fileTypeDatabaseIds` array will return as false.
     * @returns < boolean >
     * @usageNotes
     * `isFileTypeDatabase` method can be called to check whether database is file type or
     * not by passing the dbTyp_Id as argument.
     */
      isFileTypeDatabase(dbTyp_Id: number = -1): boolean {
        let fileTypeDatabaseIds = [
            DatabaseEnum.databaseId.FLATFILE,
            DatabaseEnum.databaseId.COBOL,
            DatabaseEnum.databaseId.SALESFORCE,
            DatabaseEnum.databaseId.DFS,
            DatabaseEnum.databaseId.JSON,
            DatabaseEnum.databaseId.HBASE,
            DatabaseEnum.databaseId.XSD,
            DatabaseEnum.databaseId.TWITTER,
            DatabaseEnum.databaseId.FACEBOOK,
            DatabaseEnum.databaseId.JMS,
            DatabaseEnum.databaseId.KAFKA,
            DatabaseEnum.databaseId.SAS,
            DatabaseEnum.databaseId.AVRO,
            DatabaseEnum.databaseId.PARQUET,
            DatabaseEnum.databaseId.DRUID,
            DatabaseEnum.databaseId.GOOGLE_DOUBLECLICK_SEARCH,
            DatabaseEnum.databaseId.GOOGLE_ANALYTICS,
            DatabaseEnum.databaseId.GOOGLE_ADWORDS,
            DatabaseEnum.databaseId.ACTIVE_DIRECTORY,
            DatabaseEnum.databaseId.OFFICE365,
            DatabaseEnum.databaseId.JSONC,  //add by sharmi on 4-3-25
            DatabaseEnum.databaseId.SHAREPOINT, //SHARMI & PIYUSH 30-08-24
            DatabaseEnum.databaseId.EXCEL,
            DatabaseEnum.databaseId.RESTAPI,
            DatabaseEnum.databaseId.SMARTSHEET// add rushiM
            
            //Add Iceberg -> needs to check
        ];

        if (fileTypeDatabaseIds.indexOf(dbTyp_Id) != -1) {
            return true;
        }
        return false;
    }

    // prepareDatabases(databases: Array<Database>): void {
    //     let database: Database = new Database();
    //     this.databasesMap.set(database.id, database);
    //     let databaseWrapper: DatabaseWrapper = this.createDatabaseWrapper(database);
    //     this.databaseWrappersMap.set(database.id, databaseWrapper);

    //     for (let i: number = 0; i < databases.length; i++) {
    //         database = databases[i] as Database;
    //         this.databasesMap.set(database.id, database);

    //         let labelValueObjs: Array<LabelValueObj> = new Array<LabelValueObj>();
    //         for (let j: number = 0; j < database.datatype.length; j++) {
    //             let dataType: Datatype = database.datatype[j] as Datatype;

    //             let labelValueObj: LabelValueObj = new LabelValueObj();

    //             labelValueObj.id = dataType.id;
    //             labelValueObj.label = dataType.name;
    //             labelValueObj.value = dataType.name;

    //             labelValueObjs.push(labelValueObj);

    //             this.datatypesMap.set(database.id + '.' + dataType.id, dataType);
    //         }

    //         databaseWrapper = this.createDatabaseWrapper(database);
    //         databaseWrapper.labelValueObjs = labelValueObjs;

    //         this.databaseWrappersMap.set(database.id, databaseWrapper);
    //     }
    // }



    getDatabase(dbTyp_Id: number): Database {
        let databaseWrapper: DatabaseWrapper = this.getDatabaseWrapper(dbTyp_Id);
        if (!databaseWrapper) return null;

        return databaseWrapper.database;
    }

    getDatatype(dbTyp_Id: number, attrDTyp_Id: number): Datatype {
        let databaseWrapper: DatabaseWrapper = this.getDatabaseWrapper(dbTyp_Id);
        if (!databaseWrapper) return null;

        let datatype: Datatype = databaseWrapper.datatypesMap.get(dbTyp_Id + '.' + attrDTyp_Id);
        if (datatype) return datatype;

        return null;
    }

    getDatatypeByName(dbTyp_Id: number, name: string): Datatype {
        let databaseWrapper: DatabaseWrapper = this.getDatabaseWrapper(dbTyp_Id);
        if (!databaseWrapper) return null;

        for (let i: number = 0; i < databaseWrapper.database.datatype.length; i++) {
            let dataType: Datatype = databaseWrapper.database.datatype[i] as Datatype;
            if (dataType.name == name) {
                return dataType;
            }
        }

        return null;
    }

    // setDatatypes(databases: Array<Database>) {
    //     let databasesTmp = [];
    //     for (let i = 0; i < databases.length; i++) {
    //         let database = databases[i];

    //         let databaseExist = this.databasesMap.get(database.id);
    //         if (databaseExist) {
    //             if (databaseExist.datatype.length == 0) {
    //                 for (let j = 0; j < database.datatype.length; j++) {
    //                     let datatypeTmp = database.datatype[j];
    //                     databaseExist.datatype.push(datatypeTmp);
    //                 }

    //                 for (let j = 0; j < databaseExist.datatype.length; j++) {
    //                     let datatypeTmp = databaseExist.datatype[j];
    //                     this.datatypesMap.set(database.id + '.' + datatypeTmp.id, datatypeTmp);
    //                 }
    //             }
    //         } else {
    //             databasesTmp.push(database);
    //         }
    //     }

    //     // this.setDatabases(databasesTmp);
    // }

    getEqDataType(nativeDbTyp_Id: number, dbTyp_Id: number, attrDTyp_Id: number,
        databaseWrapper: DatabaseWrapper): any {
        let dataType = this.getDatatype(dbTyp_Id, attrDTyp_Id);
        let eqTag = databaseWrapper.equivalentTag;
        let eqDataType = this.getDatatype(nativeDbTyp_Id, dataType[eqTag]);

        if (nativeDbTyp_Id == -2)
            return dataType;
        else
            return eqDataType;
    }

    getDatabaseName(dbTyp_Id: number): string {
        let database: Database = this.getDatabase(dbTyp_Id);
        if (!database) return '';

        return database.name;
    }

    getDatabaseDesignName(dbTyp_Id: number): string {
        let database: Database = this.getDatabase(dbTyp_Id);
        if (!database) return '';

        return database.designName;
    }

    getDefaultDatatype(dbTyp_Id: number): Datatype {
        let database: Database = this.getDatabase(dbTyp_Id);
        if (!database) return null;

        for (let i: number = 0; i < database.datatype.length; i++) {
            if (database.datatype[i].id == database.defaultId) {
                return database.datatype[i];
            }
        }

        return null;
    }

    getDefaultDatatypeForRecord(dbTyp_Id: number, recordDefaultId: number): Datatype {
        let database: Database = this.getDatabase(dbTyp_Id);
        if (!database) return null;

        for (let i: number = 0; i < database.datatype.length; i++) {
            if (database.datatype[i].id == recordDefaultId) {
                return database.datatype[i];
            }
        }

        return null;
    }

    isRelational(dbTyp_Id: number): boolean {
        let database: Database = this.getDatabase(dbTyp_Id);
        if (!database) return false;

        return database.complex == 'N' && database.hasParentChild == 'N';
    }

    isComplex(dbTyp_Id: number): boolean {
        let database: Database = this.getDatabase(dbTyp_Id);
        if (!database) return false;

        return database.complex == 'Y';
    }

    isParentChild(dbTyp_Id: number): boolean {
        let database: Database = this.getDatabase(dbTyp_Id);
        if (!database) return false;

        return database.hasParentChild == 'Y';
    }

    getRowCount(dbTyp_Id: number) {
        let database: Database = this.getDatabase(dbTyp_Id);
        if (!database) return false;

        switch (database.code) {
            case "CO":
            case "XD": return 2;
            case "HB": return 3;
            default: return 1;
        }
    }

    isNumberFamily(dbTyp_Id: number, attrDTyp_Id: number): boolean {
        return this.getDataTypeFamilyId(dbTyp_Id, attrDTyp_Id) == DatabaseEnum.datatypes_constants.FAMILY_DATATYPE_NUMBER_ID;
    }

    isDateFamily(dbTyp_Id: number, attrDTyp_Id: number): boolean {
        return this.getDataTypeFamilyId(dbTyp_Id, attrDTyp_Id) == DatabaseEnum.datatypes_constants.FAMILY_DATATYPE_DATE_ID;
    }

    isStringFamily(dbTyp_Id: number, attrDTyp_Id: number): boolean {
        return this.getDataTypeFamilyId(dbTyp_Id, attrDTyp_Id) == DatabaseEnum.datatypes_constants.FAMILY_DATATYPE_STRING_ID;
    }

    equivalentDbTyp_Id(dbTyp_Id: number, attrDTyp_Id: number, desiredDbTyp_Id: number) {
        if (dbTyp_Id == desiredDbTyp_Id) return attrDTyp_Id;

        let dataType = this.getDatatype(dbTyp_Id, attrDTyp_Id);
        if (dataType) {
            let database = this.getDatabase(desiredDbTyp_Id);
        }

        return attrDTyp_Id;
    }

    isLicensed(dbTyp_Id: number) {
        let database = this.getDatabase(dbTyp_Id);
        if (!database) return false;

        return database.isLicensed;
    }

    verifyWindowAttributeDataType(attrDTyp_Id: number): boolean {
        if (attrDTyp_Id == 91 || attrDTyp_Id == 93 ||
            attrDTyp_Id == 94 || attrDTyp_Id == 96) {
            return true;
        }
        return false;
    }
    getDefaultNumericId(dbTyp_Id: number) {
        let database: Database = this.getDatabase(dbTyp_Id);
        if (!database) return null;

        for (let i: number = 0; i < database.datatype.length; i++) {
            if (database.datatype[i].id == database.defaultNumericId)
                return database.datatype[i];
        }

        return null;
    }

    isSameFamily(dbTyp_Id1: number, attrDTyp_Id1: number, dbTyp_Id2: number, attrDTyp_Id2: number, allowString: boolean, intTolet: boolean): boolean {
        let family1 = this.getDataTypeFamilyId(dbTyp_Id1, attrDTyp_Id1);
        let family2 = this.getDataTypeFamilyId(dbTyp_Id2, attrDTyp_Id2);

        if (family1 == family2) return true;

        if (allowString && family1 == DatabaseEnum.family.STRING) return true;

        if (intTolet && family1 == DatabaseEnum.family.NUMBER &&
            family2 == DatabaseEnum.family.STRING) return true;

        return false;
    }

    getDataTypeFamilyId(dbTyp_Id: number, attrDTyp_Id: number): number {
        let datatype = this.getDatatype(dbTyp_Id, attrDTyp_Id);
        if (!datatype) return -1;

        return datatype.family;
    }

    validateAttributeFamily(dbTyp_Id: number, attrDTyp_Id: number, dbTyp_Id2: number, attrDTyp_Id2: number,
        allowString: boolean, intTolet: boolean): string {
        if (this.isSameFamily(dbTyp_Id, attrDTyp_Id, dbTyp_Id2, attrDTyp_Id2, allowString, intTolet)) {
            return '0';
        }

        return 'DIFF_TYPE';
    }

    getDatatypeName(dbTyp_Id: number, attrDTyp_Id: number) {
        let datatype = this.getDatatype(dbTyp_Id, attrDTyp_Id);
        if (!datatype) return '';

        return datatype.name;
    }

    getParamType(dbTyp_Id: number, param: Param): any {
        let type = '';
        let datatype = this.getDatatype(dbTyp_Id, param.paramDTyp_Id);
        type = datatype.name;

        let precScale = '';
        if (datatype.enableprecision == 'y')
            precScale = param.paramPrec.toString();
        if (datatype.enablescale == 'y')
            precScale += ',' + param.paramScale;

        if (precScale != '')
            type += ' (' + precScale + ')';

        return type;
    }

    showAttrPrec(dbTyp_Id: number, attrDTyp_Id: number, attrPrec: number): any {

        let datatype: Datatype = this.getDatatype(dbTyp_Id, attrDTyp_Id);

        if (!datatype) return '';
        if (datatype.enableprecision == 'n') return '';

        return attrPrec;
    }


    showAttrScale(dbTyp_Id: number, attrDTyp_Id: number, attrScale: number): any {

        let datatype: Datatype = this.getDatatype(dbTyp_Id, attrDTyp_Id);

        if (!datatype) return '';
        if (datatype.enablescale == 'n') return '';

        return attrScale;
    }

    createDatabaseWrapper(database: Database): DatabaseWrapper {
        switch (database.id) {
            case -6:
                let dataMaskingWrapper: DataMaskingWrapper = this.databaseWrappersMap.get(database.id) as DataMaskingWrapper;
                if (dataMaskingWrapper) return dataMaskingWrapper;

                dataMaskingWrapper = new DataMaskingWrapper(database);
                this.databaseWrappersMap.set(database.id, dataMaskingWrapper);

                return dataMaskingWrapper;

            case -2:
                let genericWrapper: GenericWrapper = this.databaseWrappersMap.get(database.id) as GenericWrapper;
                if (genericWrapper) return genericWrapper;

                genericWrapper = new GenericWrapper(database);
                this.databaseWrappersMap.set(database.id, genericWrapper);

                return genericWrapper;
            case 0:
                let netezzaWrapper: NetezzaWrapper = this.databaseWrappersMap.get(database.id) as NetezzaWrapper;
                if (netezzaWrapper) return netezzaWrapper;

                netezzaWrapper = new NetezzaWrapper(database);
                this.databaseWrappersMap.set(database.id, netezzaWrapper);

                return netezzaWrapper;

            case 1:
                let teradataWrapper: TeradataWrapper = this.databaseWrappersMap.get(database.id) as TeradataWrapper;
                if (teradataWrapper) return teradataWrapper;

                teradataWrapper = new TeradataWrapper(database);
                this.databaseWrappersMap.set(database.id, teradataWrapper);

                return teradataWrapper;

            case 2:
                let oracleWrapper: OracleWrapper = this.databaseWrappersMap.get(database.id) as OracleWrapper;
                if (oracleWrapper) return oracleWrapper;

                oracleWrapper = new OracleWrapper(database);
                this.databaseWrappersMap.set(database.id, oracleWrapper);

                return oracleWrapper;

            case 3:
                let flatfileWrapper: FlatfileWrapper = this.databaseWrappersMap.get(database.id) as FlatfileWrapper;
                if (flatfileWrapper) return flatfileWrapper;
                flatfileWrapper = new FlatfileWrapper(database);
                this.databaseWrappersMap.set(database.id, flatfileWrapper);
                return flatfileWrapper;

            case 4:
                let postgresWrapper: PostgresWrapper = this.databaseWrappersMap.get(database.id) as PostgresWrapper;
                if (postgresWrapper) return postgresWrapper;
                postgresWrapper = new PostgresWrapper(database);
                this.databaseWrappersMap.set(database.id, postgresWrapper);
                return postgresWrapper;

            case 5:
                let db2Wrapper: Db2Wrapper = this.databaseWrappersMap.get(database.id) as Db2Wrapper;
                if (db2Wrapper) return db2Wrapper;
                db2Wrapper = new Db2Wrapper(database);
                this.databaseWrappersMap.set(database.id, db2Wrapper);

                return db2Wrapper;


            case 6:
                let hiveWrapper: HiveWrapper = this.databaseWrappersMap.get(database.id) as HiveWrapper;
                if (hiveWrapper) return hiveWrapper;
                hiveWrapper = new HiveWrapper(database);
                this.databaseWrappersMap.set(database.id, hiveWrapper);

                return hiveWrapper;


            case 7:
                let msWrapper: MssqlWrapper = this.databaseWrappersMap.get(database.id) as MssqlWrapper;
                if (msWrapper) return msWrapper;
                msWrapper = new MssqlWrapper(database);
                this.databaseWrappersMap.set(database.id, msWrapper);

                return msWrapper;


            case 8:
                let biginsightsWrapper: BiginsightsWrapper = this.databaseWrappersMap.get(database.id) as BiginsightsWrapper;
                if (biginsightsWrapper) return biginsightsWrapper;
                biginsightsWrapper = new BiginsightsWrapper(database);
                this.databaseWrappersMap.set(database.id, biginsightsWrapper);

                return biginsightsWrapper;



            case 9:
                let cobolWrapper: CobolWrapper = this.databaseWrappersMap.get(database.id) as CobolWrapper;
                if (cobolWrapper) return cobolWrapper;
                cobolWrapper = new CobolWrapper(database);
                this.databaseWrappersMap.set(database.id, cobolWrapper);

                return cobolWrapper;


            case 10:
                let salesforceWrapper: SalesforceWrapper = this.databaseWrappersMap.get(database.id) as SalesforceWrapper;
                if (salesforceWrapper) return salesforceWrapper;
                salesforceWrapper = new SalesforceWrapper(database);
                this.databaseWrappersMap.set(database.id, salesforceWrapper);

                return salesforceWrapper;

            case 11:
                let exadataWrapper: ExadataWrapper = this.databaseWrappersMap.get(database.id) as ExadataWrapper;
                if (exadataWrapper) return exadataWrapper;
                exadataWrapper = new ExadataWrapper(database);
                this.databaseWrappersMap.set(database.id, exadataWrapper);

                return exadataWrapper;


            case 12:
                let gpWrapper: GreenPlumWrapper = this.databaseWrappersMap.get(database.id) as GreenPlumWrapper;
                if (gpWrapper) return gpWrapper;
                gpWrapper = new GreenPlumWrapper(database);
                this.databaseWrappersMap.set(database.id, gpWrapper);

                return gpWrapper;


            case 13:
                let hawqWrapper: HawqWrapper = this.databaseWrappersMap.get(database.id) as HawqWrapper;
                if (hawqWrapper)
                    hawqWrapper = new HawqWrapper(database);
                this.databaseWrappersMap.set(database.id, hawqWrapper);

                return hawqWrapper;


            case 14:
                let hdfsCommandWrapper: HdfsCommandWrapper = this.databaseWrappersMap.get(database.id) as HdfsCommandWrapper;
                if (hdfsCommandWrapper) return hdfsCommandWrapper;
                hdfsCommandWrapper = new HdfsCommandWrapper(database);
                this.databaseWrappersMap.set(database.id, hdfsCommandWrapper);

                return hdfsCommandWrapper;



            case 15:
                let jsonWrapper: JsonWrapper = this.databaseWrappersMap.get(database.id) as JsonWrapper;
                if (jsonWrapper) return jsonWrapper;
                jsonWrapper = new JsonWrapper(database);
                this.databaseWrappersMap.set(database.id, jsonWrapper);

                return jsonWrapper;


            case 16:
                let hbaseWrapper: HbaseWrapper = this.databaseWrappersMap.get(database.id) as HbaseWrapper;
                if (hbaseWrapper) return hbaseWrapper;
                hbaseWrapper = new HbaseWrapper(database);
                this.databaseWrappersMap.set(database.id, hbaseWrapper);

                return hbaseWrapper;



            case 17:
                let xsdWrapper: XsdWrapper = this.databaseWrappersMap.get(database.id) as XsdWrapper;
                if (xsdWrapper) return xsdWrapper;
                xsdWrapper = new XsdWrapper(database);
                this.databaseWrappersMap.set(database.id, xsdWrapper);

                return xsdWrapper;


            case 18:
                let spliceMachineWrapper: SpliceMachineWrapper = this.databaseWrappersMap.get(database.id) as SpliceMachineWrapper;
                if (spliceMachineWrapper) return spliceMachineWrapper;
                spliceMachineWrapper = new SpliceMachineWrapper(database);
                this.databaseWrappersMap.set(database.id, spliceMachineWrapper);

                return spliceMachineWrapper;



            case 19:
                let twitterWrapper: TwitterWrapper = this.databaseWrappersMap.get(database.id) as TwitterWrapper;
                if (twitterWrapper) return twitterWrapper;
                twitterWrapper = new TwitterWrapper(database);
                this.databaseWrappersMap.set(database.id, twitterWrapper);

                return twitterWrapper;


            case 20:
                let facebookWrapper: FacebookWrapper = this.databaseWrappersMap.get(database.id) as FacebookWrapper;
                if (facebookWrapper) return facebookWrapper;
                facebookWrapper = new FacebookWrapper(database);
                this.databaseWrappersMap.set(database.id, facebookWrapper);

                return facebookWrapper;


            case 21:
                let sparkWrapper: SparkWrapper = this.databaseWrappersMap.get(database.id) as SparkWrapper;
                if (sparkWrapper) return sparkWrapper;
                sparkWrapper = new SparkWrapper(database);
                this.databaseWrappersMap.set(database.id, sparkWrapper);

                return sparkWrapper;


            case 22:
                let jmsWrapper: JmsWrapper = this.databaseWrappersMap.get(database.id) as JmsWrapper;
                if (jmsWrapper) return jmsWrapper;
                jmsWrapper = new JmsWrapper(database);
                this.databaseWrappersMap.set(database.id, jmsWrapper);

                return jmsWrapper;

            case 23:
                let kafkaWrapper: KafkaWrapper = this.databaseWrappersMap.get(database.id) as KafkaWrapper;
                if (kafkaWrapper) return kafkaWrapper;
                kafkaWrapper = new KafkaWrapper(database);
                this.databaseWrappersMap.set(database.id, kafkaWrapper);

                return kafkaWrapper;


            case 24:
                let cassandraWrapper: CassandraWrapper = this.databaseWrappersMap.get(database.id) as CassandraWrapper;
                if (cassandraWrapper) return cassandraWrapper;
                cassandraWrapper = new CassandraWrapper(database);
                this.databaseWrappersMap.set(database.id, cassandraWrapper);

                return cassandraWrapper;


            case 25:
                let sybaseWrapper: SybaseWrapper = this.databaseWrappersMap.get(database.id) as SybaseWrapper;
                if (sybaseWrapper) return sybaseWrapper;
                sybaseWrapper = new SybaseWrapper(database);
                this.databaseWrappersMap.set(database.id, sybaseWrapper);

                return sybaseWrapper;


            case 26:
                let sasWrapper: SasWrapper = this.databaseWrappersMap.get(database.id) as SasWrapper;
                if (sasWrapper) return sasWrapper;
                sasWrapper = new SasWrapper(database);
                this.databaseWrappersMap.set(database.id, sasWrapper);

                return sasWrapper;


            case 27:
                let thoughtspotWrapper: ThoughtspotWrapper = this.databaseWrappersMap.get(database.id) as ThoughtspotWrapper;
                if (thoughtspotWrapper) return thoughtspotWrapper;
                thoughtspotWrapper = new ThoughtspotWrapper(database);
                this.databaseWrappersMap.set(database.id, thoughtspotWrapper);

                return thoughtspotWrapper;


            case 28:
                let snowflakeWrapper: SnowflakeWrapper = this.databaseWrappersMap.get(database.id) as SnowflakeWrapper;
                if (snowflakeWrapper) return snowflakeWrapper;
                snowflakeWrapper = new SnowflakeWrapper(database);
                this.databaseWrappersMap.set(database.id, snowflakeWrapper);

                return snowflakeWrapper;


            case 29:
                let mysqlWrapper: MysqlWrapper = this.databaseWrappersMap.get(database.id) as MysqlWrapper;
                if (mysqlWrapper) return mysqlWrapper;
                mysqlWrapper = new MysqlWrapper(database);
                this.databaseWrappersMap.set(database.id, mysqlWrapper);

                return mysqlWrapper;


            case 30:
                let bigqueryWrapper: BigqueryWrapper = this.databaseWrappersMap.get(database.id) as BigqueryWrapper;
                if (bigqueryWrapper) return bigqueryWrapper;
                bigqueryWrapper = new BigqueryWrapper(database);
                this.databaseWrappersMap.set(database.id, bigqueryWrapper);

                return bigqueryWrapper;


            case 31:
                let restWrapper: RestWrapper = this.databaseWrappersMap.get(database.id) as RestWrapper;
                if (restWrapper) return restWrapper;
                restWrapper = new RestWrapper(database);
                this.databaseWrappersMap.set(database.id, restWrapper);

                return restWrapper;


            case 32:
                let avroWrapper: AvroWrapper = this.databaseWrappersMap.get(database.id) as AvroWrapper;
                if (avroWrapper) return avroWrapper;
                avroWrapper = new AvroWrapper(database);
                this.databaseWrappersMap.set(database.id, avroWrapper);

                return avroWrapper;


            case 33:
                let parquetWrapper: ParquetWrapper = this.databaseWrappersMap.get(database.id) as ParquetWrapper;
                if (parquetWrapper) return parquetWrapper;
                parquetWrapper = new ParquetWrapper(database);
                this.databaseWrappersMap.set(database.id, parquetWrapper);

                return parquetWrapper;


            case 34:
                let amazonS3Wrapper: AmazonS3Wrapper = this.databaseWrappersMap.get(database.id) as AmazonS3Wrapper;
                if (amazonS3Wrapper) return amazonS3Wrapper;
                amazonS3Wrapper = new AmazonS3Wrapper(database);
                this.databaseWrappersMap.set(database.id, amazonS3Wrapper);

                return amazonS3Wrapper;


            case 35:
                let druidWrapper: DruidWrapper = this.databaseWrappersMap.get(database.id) as DruidWrapper;
                if (druidWrapper) return druidWrapper;
                druidWrapper = new DruidWrapper(database);
                this.databaseWrappersMap.set(database.id, druidWrapper);

                return druidWrapper;


            case 36:
                let redshiftWrapper: RedshiftWrapper = this.databaseWrappersMap.get(database.id) as RedshiftWrapper;
                if (redshiftWrapper) return redshiftWrapper;
                redshiftWrapper = new RedshiftWrapper(database);
                this.databaseWrappersMap.set(database.id, redshiftWrapper);

                return redshiftWrapper;


            case 37:
                let googleCloudStorageWrapper: GoogleCloudStorageWrapper = this.databaseWrappersMap.get(database.id) as GoogleCloudStorageWrapper;
                if (googleCloudStorageWrapper) return googleCloudStorageWrapper;
                googleCloudStorageWrapper = new GoogleCloudStorageWrapper(database);
                this.databaseWrappersMap.set(database.id, googleCloudStorageWrapper);

                return googleCloudStorageWrapper;


            case 38:
                let auroraWrapper: AuroraWrapper = this.databaseWrappersMap.get(database.id) as AuroraWrapper;
                if (auroraWrapper) return auroraWrapper;
                auroraWrapper = new AuroraWrapper(database);
                this.databaseWrappersMap.set(database.id, auroraWrapper);

                return auroraWrapper;

             //SHARMI & PIYUSH 30-08-24
            case 77:
                let sharepointWrapper: SharePointWrapper = this.databaseWrappersMap.get(database.id) as SharePointWrapper;
                if (sharepointWrapper) return sharepointWrapper;
                sharepointWrapper = new SharePointWrapper(database);
                this.databaseWrappersMap.set(database.id, sharepointWrapper);

                return sharepointWrapper;



            case 39:
                let office365Wrapper: Office365Wrapper = this.databaseWrappersMap.get(database.id) as Office365Wrapper;
                if (office365Wrapper) return office365Wrapper;
                office365Wrapper = new Office365Wrapper(database);
                this.databaseWrappersMap.set(database.id, office365Wrapper);

                return office365Wrapper;

            case 79:
                    let jsoncWrapper: JsonCWrapper = this.databaseWrappersMap.get(database.id) as JsonCWrapper;
                    if (jsoncWrapper) return jsoncWrapper;
                    jsoncWrapper = new JsonCWrapper(database);
                    this.databaseWrappersMap.set(database.id, jsoncWrapper);

                    return jsoncWrapper;

            case 80:
                   console.log('Creating SmartsheetWrapper for ID 80');
                    let smartsheetWrapper: SmartsheetWrapper = this.databaseWrappersMap.get(database.id) as SmartsheetWrapper;
                    if (smartsheetWrapper) return smartsheetWrapper;
                    smartsheetWrapper = new SmartsheetWrapper(database);
                    this.databaseWrappersMap.set(database.id, smartsheetWrapper);

                    return smartsheetWrapper;


            case 40:
                let googleDoubleClickSearchWrapper: GoogleDoubleClickSearchWrapper = this.databaseWrappersMap.get(database.id) as GoogleDoubleClickSearchWrapper;
                if (googleDoubleClickSearchWrapper) return googleDoubleClickSearchWrapper;
                googleDoubleClickSearchWrapper = new GoogleDoubleClickSearchWrapper(database);
                this.databaseWrappersMap.set(database.id, googleDoubleClickSearchWrapper);

                return googleDoubleClickSearchWrapper;


            case 41:
                let dentrixWrapper: DentrixWrapper = this.databaseWrappersMap.get(database.id) as DentrixWrapper;
                if (dentrixWrapper) return dentrixWrapper;
                dentrixWrapper = new DentrixWrapper(database);
                this.databaseWrappersMap.set(database.id, dentrixWrapper);

                return dentrixWrapper;


            case 42:
                let eagleSoftWrapper: EagleSoftWrapper = this.databaseWrappersMap.get(database.id) as EagleSoftWrapper;
                if (eagleSoftWrapper) return eagleSoftWrapper;
                eagleSoftWrapper = new EagleSoftWrapper(database);
                this.databaseWrappersMap.set(database.id, eagleSoftWrapper);

                return eagleSoftWrapper;


            case 43:
                let googleAnalyticsWrapper: GoogleAnalyticsWrapper = this.databaseWrappersMap.get(database.id) as GoogleAnalyticsWrapper;
                if (googleAnalyticsWrapper) return googleAnalyticsWrapper;
                googleAnalyticsWrapper = new GoogleAnalyticsWrapper(database);
                this.databaseWrappersMap.set(database.id, googleAnalyticsWrapper);

                return googleAnalyticsWrapper;


            case 44:
                let googleAdwordsWrapper: GoogleAdwordsWrapper = this.databaseWrappersMap.get(database.id) as GoogleAdwordsWrapper;
                if (googleAdwordsWrapper) return googleAdwordsWrapper;
                googleAdwordsWrapper = new GoogleAdwordsWrapper(database);
                this.databaseWrappersMap.set(database.id, googleAdwordsWrapper);

                return googleAdwordsWrapper;


            case 45:
                let googlePubSubWrapper: GooglePubSubWrapper = this.databaseWrappersMap.get(database.id) as GooglePubSubWrapper;
                if (googlePubSubWrapper) return googlePubSubWrapper;
                googlePubSubWrapper = new GooglePubSubWrapper(database);
                this.databaseWrappersMap.set(database.id, googlePubSubWrapper);

                return googlePubSubWrapper;

            case 46:
                let mariaWrapper: MariaWrapper = this.databaseWrappersMap.get(database.id) as MariaWrapper;
                if (mariaWrapper) return mariaWrapper;
                mariaWrapper = new MariaWrapper(database);
                this.databaseWrappersMap.set(database.id, mariaWrapper);

                return mariaWrapper;


            case 47:
                let azure_blob_storageWrapper: Azure_blob_storageWrapper = this.databaseWrappersMap.get(database.id) as Azure_blob_storageWrapper;
                if (azure_blob_storageWrapper) return azure_blob_storageWrapper;
                azure_blob_storageWrapper = new Azure_blob_storageWrapper(database);
                this.databaseWrappersMap.set(database.id, azure_blob_storageWrapper);

                return azure_blob_storageWrapper;


            case 48:
                let activeDirectoryWrapper: ActiveDirectoryWrapper = this.databaseWrappersMap.get(database.id) as ActiveDirectoryWrapper;
                if (activeDirectoryWrapper) return activeDirectoryWrapper;
                activeDirectoryWrapper = new ActiveDirectoryWrapper(database);
                this.databaseWrappersMap.set(database.id, activeDirectoryWrapper);

                return activeDirectoryWrapper;


            case 49:
                let connectDirectMainframeWrapper: ConnectDirectMainframeWrapper = this.databaseWrappersMap.get(database.id) as ConnectDirectMainframeWrapper;
                if (connectDirectMainframeWrapper) return connectDirectMainframeWrapper;
                connectDirectMainframeWrapper = new ConnectDirectMainframeWrapper(database);
                this.databaseWrappersMap.set(database.id, connectDirectMainframeWrapper);

                return connectDirectMainframeWrapper;

            case 50:
                let mongoDbWrapper: MongoDbWrapper = this.databaseWrappersMap.get(database.id) as MongoDbWrapper;
                if (mongoDbWrapper) return mongoDbWrapper;
                mongoDbWrapper = new MongoDbWrapper(database);
                this.databaseWrappersMap.set(database.id, mongoDbWrapper);

                return mongoDbWrapper;

            case 52:
                let azureSynapseWrapper: AzureSynapseWrapper = this.databaseWrappersMap.get(database.id) as AzureSynapseWrapper;
                if (azureSynapseWrapper) return azureSynapseWrapper;
                azureSynapseWrapper = new AzureSynapseWrapper(database);
                this.databaseWrappersMap.set(database.id, azureSynapseWrapper);

                return azureSynapseWrapper;

            case 53:
                let iotHubWrapper: IotHubWrapper = this.databaseWrappersMap.get(database.id) as IotHubWrapper;
                if (iotHubWrapper) return iotHubWrapper;
                iotHubWrapper = new IotHubWrapper(database);
                this.databaseWrappersMap.set(database.id, iotHubWrapper);

                return iotHubWrapper;
            case 54:
                let sapHanaWrapper: SapHanaWrapper = this.databaseWrappersMap.get(database.id) as SapHanaWrapper;
                if (sapHanaWrapper) return sapHanaWrapper;
                sapHanaWrapper = new SapHanaWrapper(database);
                this.databaseWrappersMap.set(database.id, sapHanaWrapper);

                return sapHanaWrapper;
            case 56:
                let phoenixWrapper: PhoenixWrapper = this.databaseWrappersMap.get(database.id) as PhoenixWrapper;
                if (phoenixWrapper) return phoenixWrapper;
                phoenixWrapper = new PhoenixWrapper(database);
                this.databaseWrappersMap.set(database.id, phoenixWrapper);

                return phoenixWrapper;
            case 57:
                let restAPIWrapper: RestAPIWrapper = this.databaseWrappersMap.get(database.id) as RestAPIWrapper;
                if (restAPIWrapper) return restAPIWrapper;
                restAPIWrapper = new RestAPIWrapper(database);
                this.databaseWrappersMap.set(database.id, restAPIWrapper);

                return restAPIWrapper;
            case 62:
                let excelWrapper : ExcelWrapper = this.databaseWrappersMap.get(database.id) as ExcelWrapper;
                if (excelWrapper) return excelWrapper;
                excelWrapper = new ExcelWrapper(database);
                this.databaseWrappersMap.set(database.id, excelWrapper);

                return excelWrapper;
            //piyush <01-11-2023>
                case 75:
                    let dynamoWrapper: DynamoWrapper = this.databaseWrappersMap.get(database.id) as DynamoWrapper;
                    if (dynamoWrapper) return dynamoWrapper;
                    dynamoWrapper = new DynamoWrapper(database);
                    this.databaseWrappersMap.set(database.id, dynamoWrapper);

                    return dynamoWrapper;

                //Mangesh & yash  <9th April 2024>
                case 76:
                    let ravenWrapper: RavenWrapper = this.databaseWrappersMap.get(database.id) as RavenWrapper;
                    if (ravenWrapper) return ravenWrapper;
                    ravenWrapper = new RavenWrapper(database);
                    this.databaseWrappersMap.set(database.id, ravenWrapper);

                    return ravenWrapper;

                case 71:
                let verticaWrapper: VerticaWrapper = this.databaseWrappersMap.get(database.id) as VerticaWrapper;
                if (verticaWrapper) return verticaWrapper;
                verticaWrapper = new VerticaWrapper(database);
                this.databaseWrappersMap.set(database.id, verticaWrapper);

                return verticaWrapper;

                case 81:
                let icebergWrapper: IcebergWrapper = this.databaseWrappersMap.get(database.id) as IcebergWrapper;
                if (icebergWrapper) return icebergWrapper;
                icebergWrapper = new IcebergWrapper(database);
                this.databaseWrappersMap.set(database.id, icebergWrapper);

                return icebergWrapper;

            default: {

            }
        }

        return null;
    }
}
